import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Socials from "../components/contact/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="contact-container">
				<div className="title contact-title">{INFO.contact.title}</div>

				<div className="subtitle contact-subtitle">
					{INFO.contact.description_1}
					&nbsp;{" "}
					<a href={`mailto:${INFO.main.email}`}>{INFO.main.email}</a><br />
					{INFO.contact.description_2}
				</div>
			</div>

			<div className="socials-container">
				<div className="contact-socials">
					<Socials />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
